import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';
import { AppEvent } from 'src/app/data/models/app-event';
import { RoomMessageDto } from 'src/app/data/models/dto/room-message.dto';
//Angular
import { UserHeaderDto } from 'src/app/data/models/dto/user-header.dto';
import { AppEventType } from 'src/app/data/models/enum/app-event-type.enum';
import { ChatTypeEnum } from 'src/app/data/models/enum/chat-type.enum';
import { UserMessage } from 'src/app/data/models/interfaces/user-message.interface';
import { ChatsGatewayService } from 'src/app/data/services/chats-gateway.service';
import { EventQueueService } from 'src/app/data/services/event-queue.service';
import { RoomsService } from 'src/app/data/services/rooms.service';
import { UsersMessagesService } from 'src/app/data/services/users-messages.service';
import { ChannelsService } from 'src/app/modules/channels/services/channels.service';
import { ChatMessageDto } from '../../../../data/models/dto/chat-message.dto';
//Models
import { RoomDto } from '../../../../data/models/dto/room.dto';
import { UserInfoDto } from '../../../../data/models/dto/user-info.dto';
import { UserMessageDto } from '../../../../data/models/dto/user-message.dto';
//Services
import { ChatsMessagesService } from '../../../../data/services/chats-messages.service';
//Utils
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Room } from 'src/app/data/models/interfaces/room.interface';
import { ChatService } from 'src/app/data/services/chat.service';
import { UserPreferencesService } from 'src/app/data/services/user-preferences.service';
import { ConfirmRoomMessageRemovedDto } from '../../../../data/models/dto/confirm-room-message-removed.dto';
import { ConfirmUserMessageRemovedDto } from '../../../../data/models/dto/confirm-user-message-removed.dto';
import { UserUtil } from '../../../../data/utils/user.utils';
import { TicketsGatewayService } from 'src/app/modules/tickets/services/tickets-gateway.service';
import { NetworkService } from 'src/app/data/services/network.service';

interface GetChatMessagesProps {
  emitLoading: boolean;
  openDetails: boolean;
}

@Component({
  selector: 'app-chats-messages-list',
  templateUrl: './chats-messages-list.component.html',
  styleUrls: ['./chats-messages-list.component.scss'],
})
export class ChatsMessagesListComponent implements OnInit, OnDestroy {
  @Output() roomEvent = new EventEmitter<RoomDto>();
  @Output() userEvent = new EventEmitter<UserInfoDto>();
  @Output() headerDto = new EventEmitter<UserHeaderDto>();
  @Output() selectedChat = new EventEmitter<boolean>();
  @Output() loadingChat = new EventEmitter<boolean>();
  @Output() existMessage = new EventEmitter<boolean>();

  @Input() initialMessageActive: boolean = false;

  @Output() showArchivedChange = new EventEmitter<boolean>();
  @Input() showArchived: boolean = false;

  @Output() showActiveTicketsChange = new EventEmitter<boolean>();
  @Input() showActiveTickets: boolean = false;

  @ViewChild(CdkVirtualScrollViewport)
  private virtualScroll!: CdkVirtualScrollViewport;

  placeholder = 'Pesquise por canais ou pessoas';
  searchText!: string;

  chatMessages: ChatMessageDto[] = [];
  initialSource: ChatMessageDto[] = [];

  clickedgroup: boolean = false;

  loading: boolean = false;

  subscriptions: Subscription = new Subscription();

  selectedItem!: ChatMessageDto;

  screenWidth: number = 0;

  showOnlyUnreadMessages: boolean = false;
  hasChatsGatewayInitialized: boolean = false;

  get isDirector() {
    const result = this.userUtil.isDirectorProfile();
    return result;
  }

  get isProfessor() {
    return this.userUtil.isProfessorProfile();
  }

  get userName() {
    return this.userUtil.getUser().firstName;
  }

  get idUser() {
    return this.userUtil.getUser().id;
  }

  constructor(
    private chatsMessagesService: ChatsMessagesService,
    private userMessagesService: UsersMessagesService,
    readonly userUtil: UserUtil,
    private eventQueue: EventQueueService,
    private readonly gatewayService: ChatsGatewayService,
    private readonly channelService: ChannelsService,
    private readonly roomService: RoomsService,
    private readonly userPreferenceService: UserPreferencesService,
    private readonly ticketGatewayService: TicketsGatewayService,
    private readonly networkService: NetworkService,
    private elRef: ElementRef,
    private chatService: ChatService,
  ) { }

  @HostListener('window:resize')
  getScreenSize() {
    this.screenWidth = window.innerWidth;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  async ngOnInit() {
    this.getScreenSize();
    this.userName;

    await this.getChatsMessages({ emitLoading: true, openDetails: true });

    let subs = this.eventQueue
      .on<RoomMessageDto>(AppEventType.SENDED_ROOM_CHAT_MESSAGE)
      .subscribe((evt) => {
        this.handleSendedRoomMessage(evt);
      });

    let subsUser = this.eventQueue
      .on<UserMessage>(AppEventType.SENDED_USER_CHAT_MESSAGE)
      .subscribe((evt) => {
        this.handleSendedUserMessage(evt);
      });

    let subReceiveRoomMessage = this.gatewayService
      .receiveRoomMessageV2()
      .subscribe((message) => this.onReceiveRoomMessage(message));

    let subReceiveRoomMessageRemoved = this.gatewayService
      .receiveRoomMessageRemoved()
      .subscribe((message) => this.onRoomMessageRemoved(message));

    let subReceiveUserMessage = this.gatewayService
      .receiveUserMessageV2()
      .subscribe((message) => this.onReceiveUserMessage(message));

    let subReceiveUserMessageRemoved = this.gatewayService
      .receiveUserMessageRemoved()
      .subscribe((message) => this.onUserMessageRemoved(message));

    let subConnectedTicket = this.gatewayService.connected().subscribe((id) => {
      console.log(`user: ${id} connected`);
    });

    let subDisconnectedTicket = this.gatewayService.disconnected().subscribe((id) => {
      console.log(`user: ${id} disconnected`);
    });

    let subReceiveClosedTicket = this.ticketGatewayService
      .receiveClosedTicket()
      .subscribe((message) => this.updateChatMessages(message.idRoom, 'closed'))

    let subReceiveCreatedTicket = this.ticketGatewayService
      .receiveCreatedTicket()
      .subscribe((message) => this.updateChatMessages(message.idRoom, 'opened'))

    const subNetwork = combineLatest([
      this.networkService.isOnline$,
      this.gatewayService.socketStatus$
    ]).subscribe(([isOnline, isChatsGatewayConnected]) => {
      if (isOnline && !isChatsGatewayConnected && this.hasChatsGatewayInitialized) {
        console.log(`${ChatsMessagesListComponent.name} Reconnecting socket...`);
        this.getChatsMessages({ emitLoading: false, openDetails: false });
      }
    });


    this.subscriptions.add(subs);
    this.subscriptions.add(subsUser);
    this.subscriptions.add(subReceiveRoomMessage);
    this.subscriptions.add(subReceiveRoomMessageRemoved);
    this.subscriptions.add(subReceiveUserMessage);
    this.subscriptions.add(subReceiveUserMessageRemoved);
    this.subscriptions.add(this.handleForwardToRoom());
    this.subscriptions.add(this.handleForwardedMessageToRoom());
    this.subscriptions.add(subConnectedTicket);
    this.subscriptions.add(subDisconnectedTicket);
    this.subscriptions.add(subReceiveClosedTicket);
    this.subscriptions.add(subReceiveCreatedTicket);
    this.subscriptions.add(subNetwork);
  }

  private handleSendedRoomMessage(evt: AppEvent<RoomMessageDto>) {
    let chatMsg = this.chatMessages.find(
      (elem) =>
        elem.type === ChatTypeEnum.ROOM_MESSAGE &&
        elem.message.id === evt.payload.idRoom
    );

    if (chatMsg) {
      chatMsg.message.lastMessage = evt.payload;
    }

    this.sortItemMessages(true);
  }

  private handleSendedUserMessage(evt: AppEvent<UserMessage>) {
    let chatMsg = this.chatMessages.find(
      (elem) =>
        elem.type === ChatTypeEnum.USER_MESSAGE &&
        elem.message.user.id === evt.payload.idDest
    );

    if (chatMsg) {
      chatMsg.message.lastMessage = evt.payload;
    }

    this.sortItemMessages(true);
  }

  filter(value: string) {
    this.searchText = value;
    if (value == undefined || value == '') {
      this.resetDatasource();
    } else {
      this.filterChatMessagesByUser(value);
    }
  }

  private hasText(text: string, compare: string): boolean {
    return text
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim()
      .includes(compare.toLowerCase());
  }

  private filterByChannelName(value: string) {
    return this.initialSource.filter((chat) => {
      if (chat.type === ChatTypeEnum.ROOM_MESSAGE) {
        const room = <RoomDto>chat.message;
        return (
          (room.name && this.hasText(room.name, value)) ||
          (room.alias && this.hasText(room.alias, value))
        );
      }
      return false;
    });
  }

  private filterChatMessagesByUserIds(ids: string[]): ChatMessageDto[] {
    const result = this.initialSource.filter((chat) => {
      if (chat.type === ChatTypeEnum.ROOM_MESSAGE) {
        const room = <RoomDto>chat.message;
        return ids.some((id) => id == room.idUser);
      } else {
        const user = (<UserMessageDto>chat.message).user;
        return ids.some((id) => id == user.id);
      }
    });
    return result;
  }

  async filterChatMessagesByUser(value: string) {
    try {
      const chatMessagesDto = await this.chatsMessagesService
        .getUsersMessagesByName(value)
        .toPromise();

      this.chatMessages = this.filterChatMessagesByUserIds(
        chatMessagesDto.map((chat) => chat.message.user.id)
      );

      if (!this.isProfessor) {
        const exclusive = chatMessagesDto.filter(
          (filtered) =>
            !this.chatMessages
              .map((chat) => chat.message.user?.id as string)
              .includes(filtered.message.user.id)
        );

        this.chatMessages.push(...exclusive);
      }
    } catch (error) {
      this.chatMessages = this.filterByChannelName(value);
    }
  }

  openDetails(chat: ChatMessageDto) {
    this.clickedgroup = true;
    this.selectedItem = chat;

    const headerData = this.createHeaderDto(chat);

    this.headerDto.emit(headerData);

    if (chat.type === ChatTypeEnum.ROOM_MESSAGE) {
      chat.message.numMessagesUnread = 0;
      const room = <RoomDto>chat.message;
      this.roomEvent.emit(room);
    } else {
      const user = (<UserMessageDto>chat.message).user;
      this.userEvent.emit(user);
    }
    this.updateTotalUnreadMessages();
  }

  private createHeaderDto(chat: ChatMessageDto): UserHeaderDto {
    let headerIdUser: string = '';
    let headerIsRoom: boolean = false;
    let headerName: string = '';
    let headerPhoto: string = '';

    if (chat.type === ChatTypeEnum.ROOM_MESSAGE) {
      const room = <RoomDto>chat.message;
      (headerName = room.name),
        (headerPhoto = '../../../assets/icons/icon-segmento-quadrado.svg');
      headerIsRoom = true;
    } else {
      const user = (<UserMessageDto>chat.message).user;
      headerIdUser = user.id;
      headerIsRoom = false;
      headerName = user.firstName + ' ' + user.lastName;
      headerPhoto = user.photo;
    }

    const headerData: UserHeaderDto = {
      id: headerIdUser,
      isRoom: headerIsRoom,
      name: headerName,
      photo: headerPhoto,
      profile: '',
    };

    return headerData;
  }

  async getChannelsAndRooms(): Promise<RoomDto[]> {
    let rooms: RoomDto[] = [];
    try {
      let channels = await this.channelService.getByEmployee().toPromise();
      if (channels.length > 0) {
        rooms = await this.roomService
          .getByChannels(channels.map((item) => item.id))
          .toPromise();
        if (!rooms || rooms.length == 0) {
          rooms = [];
        }

        rooms = rooms.map((_item) => {
          _item.archived = this.userPreferenceService.archivedRooms.includes(
            _item.id
          );

          _item.unread =
            (this.userPreferenceService.unreadRooms.includes(_item.id) ||
              _item.numMessagesUnread > 0) &&
            this.userPreferenceService.getLastMessageId(_item.id) !==
            _item.lastMessage._id;

          return _item;
        });
      }
      return rooms;
    } catch (error) {
      console.log(error);
      return rooms;
    }
  }

  async getChatsMessages({ emitLoading, openDetails }: GetChatMessagesProps) {

    if (emitLoading) {
      this.loading = true;
      this.loadingChat.emit(true);
    }

    try {
      let rooms = await this.getChannelsAndRooms();

      if (rooms) {
        this.mergeRoomMessages(rooms);
        this.gatewayService.joinRooms(rooms.map((r) => r.id));
      }

      let userMessages = await this.userMessagesService
        .getChatUsers(this.userUtil.getUser().id)
        .toPromise();

      if (userMessages) {
        userMessages = userMessages.map((_item) => {
          _item.archived =
            this.userPreferenceService.archivedUserChats.includes(
              _item.user.id
            );

          _item.unread =
            (this.userPreferenceService.unreadUserChats.includes(
              _item.user.id
            ) ||
              _item.numMessagesUnread > 0) &&
            this.userPreferenceService.getLastMessageId(_item.user.id) !==
            _item.lastMessage.id;

          return _item;
        });

        this.mergeUserMessages(userMessages);
        this.gatewayService.joinPrivateRoom(this.idUser);
      }

      this.sortItemMessages(true);
      this.updateTotalUnreadMessages();

      this.initialSource = this.chatMessages;

      if (this.screenWidth > 800) {
        if (!this.initialMessageActive && openDetails) {
          this.selectedItem = this.chatMessages[0];
          this.openDetails(this.selectedItem);
        }
      }
      if (this.chatMessages.length === 0) {
        this.existMessage.emit(false);
      } else {
        this.existMessage.emit(true);
      }
    } catch (error) {
      console.log(error);
      this.existMessage.emit(false);
    } finally {
      this.hasChatsGatewayInitialized = true;
      this.loading = false;
      this.loadingChat.emit(false);
    }
  }

  sortItemMessages(event: any) {
    if (event) {
      this.chatMessages = [
        ...this.chatMessages.sort((a, b) => {
          if (a === b) {
            return 0;
          } else if (!a.message.lastMessage) {
            return 1;
          } else if (!b.message.lastMessage) {
            return -1;
          } else {
            return a.message?.lastMessage?.dtMessage >
              b.message?.lastMessage?.dtMessage
              ? -1
              : 1;
          }
        }),
      ];
    }
  }

  private updateChatMessages(idRoom: string, action: string) {
    this.chatMessages = this.chatMessages.map(chat => {
      if (chat.message.id === idRoom) {
        return {
          ...chat,
          message: {
            ...chat.message,
            activeTicket: action === 'opened',
          },
        };
      }
      return chat;
    });
  }

  private resetDatasource() {
    this.chatMessages = this.initialSource;
  }

  handleSelectedChat($event: any) {
    if ($event) {
      if (this.elRef.nativeElement) {
        this.selectedChat.emit(true);
      }
    }
  }

  private findChatByRoom(idRoom: string) {
    return this.chatMessages.find(
      (x) => x.type === ChatTypeEnum.ROOM_MESSAGE && x.message.id == idRoom
    );
  }

  private findChatByAuthorAndDest(idAuthor: string, idDest: string) {
    return this.chatMessages.find(
      (x) =>
        (x.type === ChatTypeEnum.USER_MESSAGE &&
          x.message.user.id === idAuthor &&
          this.idUser === idDest) ||
        (this.idUser === idAuthor && x.message.user.id === idDest)
    );
  }

  private onReceiveRoomMessage(message: RoomMessageDto) {
    const chat = this.findChatByRoom(message.idRoom);

    if (chat) {
      if (
        !this.selectedItem ||
        (this.selectedItem && this.selectedItem != chat)
      ) {
        this.updateNumMessagesUnread(chat);
      }
      this.updateLastMessage(chat, message);
    }
  }

  private onRoomMessageRemoved(message: ConfirmRoomMessageRemovedDto) {
    let chat = this.findChatByRoom(message.idRoom);

    if (chat && chat.message?.lastMessage?.id == message.id) {
      chat.message.lastMessage.active = false;
    }
  }

  private onReceiveUserMessage(message: UserMessage) {
    const chat = this.findChatByAuthorAndDest(message.idAuthor, message.idDest);

    if (chat) {
      if (
        !this.selectedItem ||
        (this.selectedItem && this.selectedItem != chat)
      ) {
        this.updateNumMessagesUnread(chat);
      }
      this.updateLastMessage(chat, message);
    }
  }

  private onUserMessageRemoved(message: ConfirmUserMessageRemovedDto) {
    let chat = this.findChatByAuthorAndDest(message.idUser, message.idDest);

    if (chat && chat.message?.lastMessage?.id == message.id) {
      chat.message.lastMessage.active = false;
    }
  }

  private updateNumMessagesUnread(chat: ChatMessageDto) {
    chat.message.numMessagesUnread++;
    chat.message.unread = true;
    this.updateTotalUnreadMessages();
  }

  private updateLastMessage(chat: ChatMessageDto, msg: any) {
    chat.message.lastMessage = msg;
    this.sortItemMessages(true);
    this.resetScrollPosition();
  }

  private handleForwardToRoom() {
    return this.eventQueue
      .on<Room>(AppEventType.FORWARD_TO_ROOM)
      .subscribe((evt) => {
        const chat = this.chatMessages.find(
          (chat) => (chat.message as RoomMessageDto).id === evt.payload.id
        );
        if (chat) {
          this.openDetails(chat);
        }
      });
  }

  private handleForwardedMessageToRoom() {
    return this.eventQueue
      .on<RoomMessageDto>(AppEventType.FORWARD_MESSAGE_TO_ROOM)
      .subscribe((evt) => {
        const chat = this.chatMessages.find(
          (chat) => (chat.message as RoomMessageDto).id === evt.payload.idRoom
        );
        if (chat) {
          chat.message.lastMessage = evt.payload;
        }
      });
  }

  //#region filters list of chats

  showArchivedRooms(event: boolean) {
    this.showArchivedChange.emit(true);
  }

  showActiveTicketRooms(event: boolean) {
    this.showActiveTicketsChange.emit(true);
  }

  filterChat(chat: ChatMessageDto, settings: [boolean, boolean, boolean]): boolean {
    const [showArchived, showActiveTickets, showOnlyUnread] = settings;

    if (showOnlyUnread) {
      return chat.message.unread === showOnlyUnread;
    }

    if (showActiveTickets) {
      return chat.message.activeTicket === showActiveTickets; 
    }

    return chat.message.archived === showArchived;
  }

  ignoreFilter = () => true;

  //#endregion

  onChatChange(chat: ChatMessageDto) {
    this.chatMessages = this.chatMessages.map((c) => {
      if (
        c.type === ChatTypeEnum.ROOM_MESSAGE &&
        c.message.id === chat.message.id
      ) {
        return chat;
      }
      if (
        c.type === ChatTypeEnum.USER_MESSAGE &&
        c.message.user.id === chat.message.user?.id
      ) {
        return chat;
      }
      return c;
    });
  }

  resetScrollPosition() {
    this.virtualScroll.scrollToIndex(0);
  }

  private updateTotalUnreadMessages() {
    const totalUnread = this.chatMessages.reduce((acumulador, chatMsgDto) => {
      return acumulador + chatMsgDto.message.numMessagesUnread;
    }, 0);
    this.chatService.setNumMessagesUnread(totalUnread);
  }

  toggleUnreadFilter() {
    this.showOnlyUnreadMessages = !this.showOnlyUnreadMessages;
  }

  private mergeRoomMessages(rooms: RoomDto[]) {
    const roomMap = new Map<string, any>();

    this.chatMessages
      .filter(item => item.type === ChatTypeEnum.ROOM_MESSAGE)
      .forEach(item => roomMap.set(`room_${item.message.id}`, item));

    rooms.forEach(r => {
      roomMap.set(`room_${r.id}`, {
        type: ChatTypeEnum.ROOM_MESSAGE,
        message: r
      });
    });

    const userMessages = this.chatMessages.filter(
      item => item.type === ChatTypeEnum.USER_MESSAGE
    );

    this.chatMessages = [...Array.from(roomMap.values()), ...userMessages];
  }

  private mergeUserMessages(users: UserMessageDto[]) {
    const userMap = new Map<string, any>();

    this.chatMessages
      .filter(item => item.type === ChatTypeEnum.USER_MESSAGE)
      .forEach(item => userMap.set(`user_${item.message.user.id}`, item));

    users.forEach(u => {
      u.user.fullname = `${u.user.firstName} ${u.user.lastName}`;
      userMap.set(`user_${u.user.id}`, {
        type: ChatTypeEnum.USER_MESSAGE,
        message: u
      });
    });

    const roomMessages = this.chatMessages.filter(
      item => item.type === ChatTypeEnum.ROOM_MESSAGE
    );

    this.chatMessages = [...roomMessages, ...Array.from(userMap.values())];
  }

}
